import moment from 'moment-timezone'
import { TFunction } from 'i18next'

const DEFAULT_DATE_FORMAT: string = 'DD-MM-YYYY'
const EDITION_LIMIT_DAYS: number = 28

export function isPastDate(date: string | Date, format: string = DEFAULT_DATE_FORMAT): boolean {
    return moment(date, format).isBefore(moment(), 'day')
}

export function titleWithPastLabel(title: string, isPast: boolean, t: TFunction): string {
    return `${title}${isPast ? ' (' + t('passed') + ')' : ''}`
}

export function isWithinEditionLimit(
    date: string | Date,
    format: string = DEFAULT_DATE_FORMAT,
    limitDays: number = EDITION_LIMIT_DAYS
): boolean {
    return moment(date, format).isAfter(moment().add(-limitDays, 'days'))
}

export function getEditionLimitDateFromToday() {
    return moment().subtract(EDITION_LIMIT_DAYS, 'day')
}
